import React, { useState, useEffect, useCallback, useMemo } from 'react';

import Modal from 'components/batches/Details/DetailsModal';
import Traductor from 'components/Traductor';

import { newVersion } from 'constants/events';
import useInterval from 'hooks/useInterval';

const CacheBuster = () => {
    const t = useMemo(() => new Traductor(), []);
    const [newVersionAvailable, setNewVersionAvailable] = useState(false);
    const [updateServiceWorkerTimer, setUpdateServiceWorkerTimer] =
        useState(null);

    useEffect(() => {
        setUpdateServiceWorkerTimer(60000);
        const onNewVersion = () => {
            setNewVersionAvailable(true);
        };
        window.addEventListener(newVersion, onNewVersion);
        return () => {
            setUpdateServiceWorkerTimer(null);
            window.removeEventListener(newVersion, onNewVersion);
        };
    }, []);

    const forceRefresh = useCallback(async () => {
        if (window.caches) {
            const names = await window.caches.keys();
            await Promise.all(names.map(name => window.caches.delete(name)));
        }
        window.location.reload();
    }, []);

    const updateServiceWorker = useCallback(() => {
        if ('serviceWorker' in navigator) {
            navigator.serviceWorker
                .getRegistration(`${process.env.PUBLIC_URL}/service-worker.js`)
                .then(response => {
                    //check for updated code
                    if (response) {
                        response.update();
                    }
                });
        }
    }, []);

    useInterval(updateServiceWorker, updateServiceWorkerTimer);

    if (!newVersionAvailable) return null;

    return (
        <Modal
            visible
            onActionPress={forceRefresh}
            title={t.getTraduction('Alert')}
            content={t.getTraduction('UpdateAvailable')}
            rightButton={t.getTraduction('BtnActualizar')}
        />
    );
};

export default CacheBuster;
